var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.purchase.flags.is_first_contract === false
        ? _c("text-row", {
            attrs: {
              compact: "",
              "label-cols-lg": 4,
              "label-cols-sm": 4,
              label: "Контракт со вторым поставщиком. Причина",
              value: _vm.purchase.first_contract_status_title,
            },
          })
        : _vm._e(),
      _c("text-row", {
        attrs: {
          compact: "",
          "label-cols-lg": 4,
          "label-cols-sm": 4,
          label: "Объект контракта - наименование закупочной сессии",
          value: _vm.purchase.purchase_terms.deliverable_group.name,
        },
      }),
      _c("text-row", {
        attrs: {
          compact: "",
          "label-cols-lg": 4,
          "label-cols-sm": 4,
          label: "Номер контракта в системе учета заказчика",
          value: _vm.purchase.customer_contract_number,
        },
      }),
      _c("text-row-price", {
        attrs: {
          compact: "",
          "label-cols-lg": 4,
          "label-cols-sm": 4,
          label: "Цена контракта, руб.",
          value: _vm.purchase.purchase_terms.contract_price,
        },
      }),
      _c("text-row", {
        attrs: {
          compact: "",
          "label-cols-lg": 4,
          "label-cols-sm": 4,
          label: "Статус контракта",
          value: _vm.purchase.contract.status.title,
        },
      }),
      _vm.purchase.actions.customer.store_second_proposal_contract
        ? _c("fl44-unknown-volume-send-second-proposal-contract", {
            staticClass: "atmo-hash-jump-point pb-0",
            attrs: { purchase: _vm.purchase, id: "second-proposal-contract" },
            on: {
              refresh: function ($event) {
                return _vm.refresh($event)
              },
            },
          })
        : _vm._e(),
      _c("text-row-proposal-specification-table", {
        attrs: { "without-vat": _vm.purchase.supplier_proposal.without_vat },
        scopedSlots: _vm._u([
          {
            key: "header",
            fn: function () {
              return [
                _c(
                  "h5",
                  {
                    staticClass:
                      "grey-color ml-1 mt-3 mb-1 main_text font-weight-bold",
                  },
                  [_vm._v("Спецификация контракта")]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.purchase.supplier_proposal.deliverables,
          callback: function ($$v) {
            _vm.$set(_vm.purchase.supplier_proposal, "deliverables", $$v)
          },
          expression: "purchase.supplier_proposal.deliverables",
        },
      }),
      _vm.purchase.is_customer &&
      !_vm.purchase.purchase_terms.without_limits &&
      _vm.purchase.contract.limits &&
      _vm.purchase.contract.limits.length > 0
        ? [
            _vm.isLimitsEdit
              ? [
                  _c("limits-editable-table", {
                    attrs: {
                      "total-cost": _vm.purchase.purchase_terms.contract_price,
                      "limit-year":
                        _vm.purchase.purchase_terms.purchase_limit_year,
                      "order-type": _vm.purchase.purchase_terms.order_type,
                      "is-data-sending": _vm.isDataSending,
                      "purchase-type": "fl44_unknown_volume",
                      "purchase-id": _vm.purchase.id,
                    },
                    on: { validate: _vm.limitsValidate },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "grey-color ml-1 mt-3 mb-1 main_text font-weight-bold",
                                },
                                [_vm._v("Измените лимиты")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "label-hint",
                          fn: function () {
                            return [
                              _vm._v(
                                " Добавьте или измените лимиты. Необходимо полностью распределить цену контракта по соответствующим лимитам. "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "label-total",
                          fn: function () {
                            return [_vm._v(" Цена контракта, руб.: ")]
                          },
                          proxy: true,
                        },
                        {
                          key: "label-variance",
                          fn: function () {
                            return [
                              _vm._v(" Отклонение от цены контракта, руб.: "),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      3180410676
                    ),
                    model: {
                      value: _vm.form.limits,
                      callback: function ($$v) {
                        _vm.$set(_vm.form, "limits", $$v)
                      },
                      expression: "form.limits",
                    },
                  }),
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase my-1 mr-2",
                          attrs: { variant: "custom-outline-secondary" },
                          on: {
                            click: function ($event) {
                              _vm.isLimitsEdit = false
                            },
                          },
                        },
                        [_vm._v("Отмена")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "b-overlay",
                    {
                      staticClass: "d-inline-block",
                      attrs: {
                        show: _vm.isDataSending,
                        opacity: "0.6",
                        rounded: "",
                        "spinner-small": "",
                        "spinner-variant": "primary",
                      },
                    },
                    [
                      _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase my-1",
                          attrs: {
                            variant: "custom-green",
                            disabled: !_vm.isLimitsValid,
                          },
                          on: { click: _vm.updateLimits },
                        },
                        [_vm._v("Сохранить")]
                      ),
                    ],
                    1
                  ),
                ]
              : [
                  _c("limits-table", {
                    attrs: { items: _vm.purchase.contract.limits },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "title",
                          fn: function () {
                            return [
                              _c(
                                "h5",
                                {
                                  staticClass:
                                    "grey-color ml-1 mt-3 mb-1 main_text font-weight-bold",
                                },
                                [_vm._v("Лимиты по КБК")]
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      false,
                      2433058336
                    ),
                  }),
                  _vm.purchase.status.id === "contract:active" &&
                  _vm.purchase.contract.supplementary_agreements.length === 0
                    ? _c(
                        "b-button",
                        {
                          staticClass: "text-uppercase my-1",
                          attrs: { variant: "custom-green" },
                          on: { click: _vm.onEditLimitsClick },
                        },
                        [_vm._v("Изменить лимиты")]
                      )
                    : _vm._e(),
                ],
          ]
        : _vm._e(),
      _c("fl44-unknown-volume-contract-files-table", {
        staticClass: "mb-0",
        attrs: {
          contract: _vm.purchase.contract,
          "download-zip": _vm.downloadZip,
        },
        scopedSlots: _vm._u([
          {
            key: "title",
            fn: function () {
              return [_vm._v("Основной контракт")]
            },
            proxy: true,
          },
        ]),
      }),
      _vm.purchase.contract.contract_disagreements &&
      _vm.purchase.contract.contract_disagreements.length > 0
        ? _c("text-row-disagreement-table", {
            attrs: {
              disagreements: _vm.purchase.contract.contract_disagreements,
            },
          })
        : _vm._e(),
      _vm.purchase.is_customer &&
      _vm.purchase.flags.has_contract &&
      _vm.purchase.contract.supplier_accounting
        ? _c("text-row-supplier-accounting", {
            scopedSlots: _vm._u(
              [
                {
                  key: "title",
                  fn: function () {
                    return [
                      _c(
                        "h5",
                        {
                          staticClass:
                            "grey-color ml-1 mt-3 mb-1 main_text font-weight-bold",
                        },
                        [_vm._v("Банковские реквизиты поставщика")]
                      ),
                    ]
                  },
                  proxy: true,
                },
              ],
              null,
              false,
              2488944890
            ),
            model: {
              value: _vm.purchase.contract.supplier_accounting,
              callback: function ($$v) {
                _vm.$set(_vm.purchase.contract, "supplier_accounting", $$v)
              },
              expression: "purchase.contract.supplier_accounting",
            },
          })
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }